const clients = [
    {
        env: 'prod',
        id: 2,
        language: 'pt',
        module: 'ZNAP_SECURITY',
        moduleName: 'portal',
        modulePath: '',
        port: 8080,
        system: 'POC',
        theme: 'poc.js',
    },
]

const getClientConfigs = (clientId) => clients.find((client) => client.id === clientId)
const configs = getClientConfigs(2)

export default {
    ...configs,
    api_port: 7000,
    ENABLE_TRACING: false,
}
